import { Extension, mergeAttributes, Node } from "@tiptap/core"
import katex from "katex"
import "katex/dist/katex.min.css"

const MathInline = Node.create({
  name: "mathInline",

  inline: true,
  group: "inline",
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      latex: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-latex") ?? "",
        renderHTML: (attributes) => {
          return {
            "data-latex": String(attributes.latex ?? ""),
          }
        },
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: "span.math-inline",
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(HTMLAttributes, { class: "math-inline" })]
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement("span")
      dom.classList.add("math-inline")
      dom.contentEditable = "false"

      const latex = typeof node.attrs.latex === "string" ? node.attrs.latex : ""
      dom.setAttribute("data-latex", latex)
      dom.innerHTML = katex.renderToString(latex, {
        displayMode: false,
        throwOnError: false,
      })

      return { dom }
    }
  },
})

const MathBlock = Node.create({
  name: "mathBlock",

  group: "block",
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      latex: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-latex") ?? "",
        renderHTML: (attributes) => {
          return {
            "data-latex": String(attributes.latex ?? ""),
          }
        },
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: "div.math-block",
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { class: "math-block" })]
  },

  addNodeView() {
    return ({ node }) => {
      const dom = document.createElement("div")
      dom.classList.add("math-block")
      dom.contentEditable = "false"

      const latex = typeof node.attrs.latex === "string" ? node.attrs.latex : ""
      dom.setAttribute("data-latex", latex)
      dom.innerHTML = katex.renderToString(latex, {
        displayMode: true,
        throwOnError: false,
      })

      return { dom }
    }
  },
})

export const MathematicsExtension = Extension.create({
  name: "mathematicsExtension",

  addExtensions() {
    return [MathInline, MathBlock]
  },
})
